import type { TransformedCmsConfigItem } from '../transformer/types';
import { Currency } from '../types';

export const BI_CONSTS = {
    LINK: 'link',
    WEBSITE_ACTIONS: 'website_actions',
    BUYERS: 'buyers',
    AGENCIES: 'agencies',
    CATERPILLARS: 'caterpillars',
    CLICK: 'click',
    HOVER: 'hover',
    USER_ACTIONS: 'user_actions',
};

export const AMOUNT_ITEMS_TO_SPLIT = 24;

export const OVERRIDE_ENTRY_CONFIG = {
    '5UTWBn0rLHCVMTo6mz6jZp': {
        urlParams: {
            source: 'category_tree_trending',
        },
    },
} as const satisfies Record<string, Partial<TransformedCmsConfigItem>>;

export const DIGITAL_MARKETING_CATEGORY_ID = 2;
export const PROGRAMMING_AND_TECH_CATEGORY_ID = 10;
export const GRAPHICS_AND_DESIGN_CATEGORY_ID = 3;
export const WRITING_AND_TRANSLATION_CATEGORY_ID = 5;
export const BUSINESS_CATEGORY_ID = 8;

export const AGENCIES_BANNER_CATEGORY_IDS = [
    DIGITAL_MARKETING_CATEGORY_ID,
    PROGRAMMING_AND_TECH_CATEGORY_ID,
    GRAPHICS_AND_DESIGN_CATEGORY_ID,
    WRITING_AND_TRANSLATION_CATEGORY_ID,
    BUSINESS_CATEGORY_ID,
];

export const BANNER_URL_KEY_MAPPING = {
    [DIGITAL_MARKETING_CATEGORY_ID]: 'skill_page_cat_marketing_sales',
    [PROGRAMMING_AND_TECH_CATEGORY_ID]: 'skill_page_cat_technical',
    [GRAPHICS_AND_DESIGN_CATEGORY_ID]: 'skill_page_cat_creative',
    [WRITING_AND_TRANSLATION_CATEGORY_ID]: 'skill_page_cat_writing',
    [BUSINESS_CATEGORY_ID]: 'skill_page_cat_business_operations',
};

export const AGENCIES_BANNER_CLICK_EVENT_TYPE = 'user_clicked_on_browse_agencies_button';
export const AGENCIES_BANNER_HOVER_BANNER_EVENT_TYPE = 'hover_on_browse_agencies_banner';
export const AGENCIES_BANNER_HOVER_BUTTON_EVENT_TYPE = 'hover_on_browse_agencies_button';

export const BI_DOMAIN_MAPPING = {
    [AGENCIES_BANNER_HOVER_BUTTON_EVENT_TYPE]: BI_CONSTS.AGENCIES,
    [AGENCIES_BANNER_HOVER_BANNER_EVENT_TYPE]: BI_CONSTS.AGENCIES,
    [AGENCIES_BANNER_CLICK_EVENT_TYPE]: BI_CONSTS.AGENCIES,
};

export const DEFAULT_CURRENCY: Currency = {
    id: 'usd',
    code: 'USD',
    symbol: '$',
    template: '{{symbol}}{{amount}}',
    name: 'United States Dollar',
    round_amount: 1000,
    exchange_rate: 1,
};
